import { WImage, WLink } from '@components/atoms'
import styles from './BrandCard.module.sass'

interface Props {
  brand?: any // BrandNode
  className?: string
}

const BrandCard = (props: Props) => {
  const { brand = undefined, className = '' } = props

  const classNames = `${styles.root} ${styles[`root--${brand.slug}`]} ${className}`
  const getContent = () => (
    <>
      <WImage
        className={styles.image}
        src={brand.immagineHome || brand.immagineStatica} // TODO: capire quale immagine ci va qui e se c'è da fare una variante per la home e una statica
        alt={brand?.imageAlt}
        maxWidth={295}
        maxHeight={350}
        objectFit="cover"
      />
      <WImage
        className={styles.logo}
        src={brand.logoTransparent}
        alt={brand?.imageAlt}
        maxWidth={100}
        maxHeight={100}
      />
    </>
  )

  return brand ? (
    <WLink href={brand?.url} className={classNames}>
      {getContent()}
    </WLink>
  ) : (
    <div className={classNames}>{getContent()}</div>
  )
}

export default BrandCard
